import { render, staticRenderFns } from "./ContinueSameCheckerboard.vue?vue&type=template&id=5bdf0e3e"
import script from "./ContinueSameCheckerboard.vue?vue&type=script&lang=js"
export * from "./ContinueSameCheckerboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports